module.exports = __webpack_public_path__ + "static/media/image_card_2.af045d97.png";